// 会员攻略相关文案
export const vipCodeTypeTextMap = {
    '非会员律师': {
        methodText: '开通会员',
        tipText: '开启线索增长通道，解锁更多流量扶持',
        btnText: '授权客服电联，解锁会员权益'
    },
    '尊享会员-7天后过期': {
        methodText: '续费会员',
        tipText: '身份即将到期，续费锁定专属权益',
        btnText: '授权客服电联，了解续费'
    },
    '体验版会员': {
        methodText: '购买会员',
        tipText: '体验将到期？开通正式会员，享流量与线索特权',
        btnText: '授权客服电联，了解会员'
    },
    '启航会员': {
        methodText: '升级会员',
        tipText: '升级享平台顶级流量扶持与线索领取额度提升',
        btnText: '授权客服电联，了解升级'
    },
    '精英会员-7天后过期': {
        methodText: '续费会员',
        tipText: '身份即将到期，续费锁定专属权益',
        btnText: '授权客服电联，了解续费'
    },
    '青春版会员': {
        methodText: '升级会员',
        tipText: '升级享平台顶级流量扶持与线索领取额度提升',
        btnText: '授权客服电联，了解升级'
    },
    '卓越版会员-7天后过期': {
        methodText: '续费会员',
        tipText: '身份即将到期，续费锁定专属权益',
        btnText: '授权客服电联，了解续费'
    },
    '精英会员': {
        methodText: '会员保障',
        tipText: '尊享流量扶持，精英专属特权已解锁',
        btnText: '您已是最高等级会员'
    },
    '尊享会员': {
        methodText: '会员保障',
        tipText: '享顶级流量扶持，尊享专属特权已解锁',
        btnText: '您已是最高等级会员'
    },
    '卓越版会员': {
        methodText: '会员保障',
        tipText: '尊享流量扶持，卓越版专属特权已解锁',
        btnText: '您已是最高等级会员'
    }
};

// 经营等级相关文案
export const businessLevelTextMap = {
    0: {
        methodText: '提升经营等级',
        tipText: '完成任务提升等级，额外免费享受专属权益',
        btnText: '立即完成任务，解锁权益'
    },
    1: {
        methodText: '提升经营等级',
        tipText: '完成任务提升等级，额外免费享受专属权益',
        btnText: '立即完成任务，解锁权益'
    },
    2: {
        methodText: '提升经营等级',
        tipText: '完成任务提升等级，额外免费享受专属权益',
        btnText: '立即完成任务，解锁权益'
    },
    3: {
        methodText: '提升经营等级',
        tipText: '完成任务提升等级，额外免费享受专属权益',
        btnText: '立即完成任务，解锁权益'
    },
    4: {
        methodText: '提升经营等级',
        tipText: '完成任务提升等级，额外免费享受专属权益',
        btnText: '立即完成任务，解锁权益'
    },
    5: {
        methodText: '保持经营等级',
        tipText: '您已经是最高经营等级啦，保持登录频率、持续创作内容即可持续享有当前顶级权益',
        btnText: '查看详情'
    }
};